var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"input-center",staticStyle:{"min-width":"150px","max-width":"150px","margin-left":"auto"},attrs:{"single-line":_vm.dense,"dense":_vm.dense,"disabled":_vm.disabled,"label":_vm.dense ? '' : _vm.label,"hide-details":_vm.showMessages
      ? false
      : _vm.dense
      ? !_vm.errorMessages || _vm.errorMessages.length == 0
      : false,"type":"number","min":_vm.min ? _vm.min : 0,"max":_vm.max ? _vm.max : 99999999,"error-messages":_vm.errorMessages},on:{"blur":function($event){return _vm.checkInputValue()},"input":function($event){_vm.changeInputByHandFlg ? _vm.$emit('input', _vm.number) : '';
    _vm.changeInputByHandFlg ? _vm.$emit('changeInputByHand') : '';}},scopedSlots:_vm._u([{key:"prepend-inner",fn:function(){return [_c('v-icon',{staticClass:"pt-2 pb-1 primary--text",attrs:{"disabled":_vm.disabled,"x-small":""},on:{"click":function($event){$event.stopPropagation();_vm.number =
          Number(_vm.number) - 1 >= (_vm.min ? _vm.min : 0)
            ? _vm.$numberFormatter.formatWithDotNoMoreThan(
                Number(_vm.number) - 1,
                Number.isInteger(_vm.dot) ? _vm.dot : 2,
                true
              )
            : _vm.min
            ? _vm.min
            : 0;
        _vm.changeInputByHandFlg ? _vm.$emit('input', _vm.number) : '';
        _vm.changeInputByHandFlg ? _vm.$emit('changeInputByHand') : '';}}},[_vm._v(" fa-minus ")])]},proxy:true},{key:"append",fn:function(){return [_c('v-icon',{staticClass:"pt-2 pb-1 primary--text",attrs:{"disabled":_vm.disabled,"x-small":""},on:{"click":function($event){$event.stopPropagation();_vm.number = _vm.number
          ? Number(_vm.number) + 1 <= (_vm.max ? _vm.max : _vm.$consts.maxValue())
            ? _vm.$numberFormatter.formatWithDotNoMoreThan(
                Number(_vm.number) + 1,
                Number.isInteger(_vm.dot) ? _vm.dot : 2,
                true
              )
            : _vm.max
          : 1;
        _vm.changeInputByHandFlg ? _vm.$emit('input', _vm.number) : '';
        _vm.changeInputByHandFlg ? _vm.$emit('changeInputByHand') : '';}}},[_vm._v(" fa-plus ")])]},proxy:true},{key:"append-outer",fn:function(){return [_vm._t("append")]},proxy:true}],null,true),model:{value:(_vm.number),callback:function ($$v) {_vm.number=$$v},expression:"number"}})
}
var staticRenderFns = []

export { render, staticRenderFns }